import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(
    private http: HttpClient
  ) { }

  public get(url: string, params?: any) {
    if (url && params && Object.keys(params)?.length) {
      url = this.updateQueryStringParameter(url, params)
    }
    return this.http.get(url)
  }

  public download(url: string, params?: any, post: boolean = false) {
    if (!post) {
      if (url && params && Object.keys(params)?.length) {
        url = this.updateQueryStringParameter(url, params)
      }
      return this.http.get<Blob>(url, { responseType: "blob" as "json" });
    } else {
      return this.http.post<Blob>(url, params, { responseType: "blob" as "json" });
    }
  }

  public post(url: string, data: any, options = {}) {
    return this.http.post(url, data, options);
  }

  public put(url: string, data: any) {
    return this.http.put(url, data)
  }

  public delete(url: string) {
    return this.http.delete(url);
  }

  public patch(url: string, data: any) {
    return this.http.patch(url, data)
  }

  private updateQueryStringParameter(uri: any, data: any) {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const value = encodeURIComponent(data[key]);
        const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        const separator = uri.indexOf('?') !== -1 ? '&' : '?';
        if (uri.match(re)) {
          uri = uri.replace(re, '$1' + key + '=' + value + '$2');
        } else {
          uri = uri + separator + key + '=' + value;
        }
      }
    }
    return uri;
  }

  public getwithOptions(url: string, options = {}) {
    return this.http.get(url, options)
  }

}
